module.exports = __webpack_public_path__ + "img/route-black-new.e2cc5993.svg";